/**
 * Chinese Quote Translations
 * 报价弹窗翻译模块 - 中文
 * 
 * 包含获取报价表单和弹窗等翻译
 */

import type { QuoteTranslations } from '../../types';

export const zhQuote: QuoteTranslations = {
  getQuote: '获取报价',
  title: '获取免费报价',
  modal: {
    title: '获取免费报价',
    subtitle: '请填写以下信息，我们的团队将在24小时内与您联系。',
    fullName: '您的姓名',
    email: '电子邮箱',
    phone: '联系电话',
    productInterest: '感兴趣的产品',
    message: '留言内容',
    placeholderName: '张三',
    placeholderEmail: 'zhangsan@example.com',
    placeholderPhone: '+86-138-0000-0000',
    placeholderProduct: '例如：工业取暖器',
    placeholderMessage: '项目详情、数量、电压要求等...',
    submit: '提交申请',
    successTitle: '申请已收到！',
    successMessage: '感谢您的关注。我们的取暖专家将审核您的需求并尽快与您联系。',
    close: '关闭',
  },
  name: '您的姓名',
  email: '电子邮箱',
  phone: '联系电话',
  company: '公司名称',
  message: '留言内容',
  submit: '提交申请',
  success: '感谢您的咨询！我们会尽快与您联系。',
};
